import lazyLoading from './lazyLoading'

export default {
  name: 'Users',
  meta: {
    expanded: false,
    title: 'menu.user.root',
    iconClass: 'vuestic-icon vuestic-icon-user'
  },

  children: [
    {
      name: 'UserList',
      path: '/users/list',
      component: lazyLoading('users/List'),
      meta: {
        title: 'menu.user.list'
      }
    },
    {
      name: 'UserEdit',
      path: '/users/edit/:id',
      component: lazyLoading('users/Form'),
      meta: {
        title: 'menu.user.edit'
      },
      hidden: true
    },
  ]
}



// WEBPACK FOOTER //
// ./src/store/modules/menu/users.js